import { createGlobalStyle } from 'styled-components';

const Global = createGlobalStyle`
  *, ::after, ::before {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-style: normal;
    font-stretch: normal;
    font-family: ${({ theme }) => theme.typography.sansSerifFontFamily};
    font-size: ${({ theme }) => theme.typography.fontSize};
    font-weight: ${({ theme }) => theme.typography.fontWeight};
    color: ${({ theme }) => theme.typography.color};
    line-height: ${({ theme }) => theme.typography.lineHeight};
    background-color: ${({ theme }) => theme.colors.black};
    background-image:
      radial-gradient(ellipse at 50% 100%, rgba(185, 103, 255, 0.55) 0%, transparent 55%),
      radial-gradient(ellipse at 0% 50%, rgba(1, 205, 254, 0.2) 0%, transparent 40%),
      radial-gradient(ellipse at 100% 50%, rgba(255, 113, 206, 0.2) 0%, transparent 40%),
      repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2rem,
        rgba(185, 103, 255, 0.06) 2rem,
        rgba(185, 103, 255, 0.06) 2.0625rem
      );
    background-attachment: fixed;
  }

  #___gatsby, #gatsby-focus-wrapper {
    all: inherit;
  }

  html {
    scroll-behavior: smooth;
  }

  ul, menu, dir {
    padding-left: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.cyan};
    text-decoration: underline;
    font-weight: bold;

    &:hover {
      color: ${({ theme }) => theme.colors.hotPink};
      text-decoration: underline;
    }

    &:visited {
      color: ${({ theme }) => theme.colors.purple};
    }
  }

  h1, h2, h3, h4, p {
    margin: 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .gatsby-resp-image-wrapper {
    margin-left: 0 !important;
    margin-right: auto !important;

    .gatsby-resp-image-image {
      box-shadow: none !important;
    }

    .gatsby-resp-image-background-image {
      background-image: none !important;
      background: linear-gradient(
        90deg,
        ${({ theme }) => theme.colors.hotPink}cc 0%,
        ${({ theme }) => theme.colors.purple}cc 50%,
        ${({ theme }) => theme.colors.blue} 100%
      ) !important;

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: url('/images/loading.gif') center no-repeat;
      }
    }
  }

  h1, h2, h3, h4 {
    text-shadow:
      0 0 0.5rem ${({ theme }) => theme.colors.purple},
      0 0 1.5rem ${({ theme }) => theme.colors.hotPink}66;
  }

  *:focus, *:active {
    outline-offset: 0.125rem;
  }

  a, button {
    transition: all 0.2s ease;
  }

  input, textarea {
    margin: 0;
    border: 0.1875rem solid ${({ theme }) => theme.colors.purple};
    background-color: ${({ theme }) => theme.colors.blue};
    color: ${({ theme }) => theme.colors.silver};
  }

  @keyframes blink {
    0%, 50% {
      opacity: 1;
    }
    51%, 100% {
      opacity: 0;
    }
  }

  @keyframes glow-pulse {
    0%, 100% {
      text-shadow:
        0 0 0.5rem ${({ theme }) => theme.colors.purple},
        0 0 1.5rem ${({ theme }) => theme.colors.hotPink}66;
    }
    50% {
      text-shadow:
        0 0 1rem ${({ theme }) => theme.colors.purple},
        0 0 2.5rem ${({ theme }) => theme.colors.hotPink}aa,
        0 0 4rem ${({ theme }) => theme.colors.cyan}44;
    }
  }

  .blink {
    animation: blink 1s infinite;
  }
`;

export default Global;
